module.exports = __webpack_public_path__ + "static/assets/8996930d8e83f63cc3341172205df460.otf";